import React, { useState, useEffect } from "react";
import {
  triggerAddInternalReview,
  triggerEditInternalReview,
  fetchReviews,
} from "../../../../store/slices/reviews";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useSelector, useDispatch } from "react-redux";
import { locationsSelector } from "../../../../store/slices/location";
import _ from "lodash";
import { endDateChangeFunction, localSelector, rangeChangeFunction, startDateChangeFunction } from "../../../../store/slices/local";
import DatePopper from "../../navbar/datePopper";

const ReviewModal = ({
  isSentiment,
  isPrompt,
  reviewData,
  setSelectedAction,
  selectedCompany,
  setFocusedReview,
  selectedLocation,
  handleDelete,
}) => {
  const dispatch = useDispatch();
  const {startDate,endDate,range}=useSelector(localSelector)
  const { internalLocations } = useSelector(locationsSelector);
  const isEditMode = !!reviewData;
  const [open, setOpenModal] = useState(reviewData ? true : false);
  const [localReviewData, setLocalReviewData] = useState(
    isEditMode ? { ...reviewData } : { ...initialReviewState }
  );
  const setStartDate = (date) => {
    dispatch(startDateChangeFunction(date));
  }
  const setEndDate = (date) => {
    dispatch(endDateChangeFunction(date));
  }
  const setRange = (range) => {
     dispatch(rangeChangeFunction(range));
  }
// console.log(localReviewData)
  useEffect(() => {
    if (isEditMode) {
      setLocalReviewData({ ...reviewData });
    }
  }, [reviewData]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setSelectedAction(null);
    setOpenModal(false);
    setLocalReviewData(
      isEditMode ? { ...reviewData } : { ...initialReviewState }
    );
    setFocusedReview({});
  };

  const selectedInternalLocationId = _.find(internalLocations, {
    placeId: reviewData?.source !== 0 ? reviewData?.placeId : localReviewData.placeId,
  })?.locationId;

  const handleSave = () => {
    if (isEditMode) {
      dispatch(
        triggerEditInternalReview(
          localReviewData,
          selectedCompany,
          startDate, endDate
        )
      );
    } else {
      dispatch(
        triggerAddInternalReview(
          localReviewData,
          selectedCompany,
          startDate, endDate
        )
      );
    }
    setOpenModal(false);
    setSelectedAction(null);
    // if ((startDate, endDate)) {
    //   // setTimeout(() => {
    //     dispatch(fetchReviews(startDate, endDate, selectedCompany));
    //   // }, 1000);
    // }
    setLocalReviewData(
      isEditMode ? { ...reviewData } : { ...initialReviewState }
    );
    setFocusedReview({});
  };

  const handleChange = (e) => {
     const { name, value } = e.target;
    setLocalReviewData({
      ...localReviewData,
      [name]:value,
    });
  };

  const isSaveDisabled = () => {
    const { sourceId, authorName, reviewDate, rating, reviewText } =
      localReviewData;
    return !sourceId || !authorName || !reviewDate || !rating || !reviewText;
  };
  // console.log(localReviewData,'locationReviewData')
  return (
    <div>
      <Stack  direction="row" spacing={2} alignItems="center">
      <DatePopper startDate={startDate} range={range} setRange={setRange} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} width={240} />
      {!isEditMode && !isSentiment && !isPrompt && (
        <Tooltip title="Add Review" arrow disableInteractive>
          <IconButton
            color="primary"
            onClick={handleOpenModal}
            sx={{ 
              border: '1px solid', 
              borderColor: 'primary.main',
              borderRadius: '4px',
              width: '40px',
              height: '40px'
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      )}
      </Stack>
      {open && (
        <Dialog open={open} maxWidth="sm" fullWidth>
          <DialogTitle>
            {isEditMode ? "Edit Review" : "Add a Review"}
          </DialogTitle>
          <Divider />
          <DialogContent>
            {!reviewData?.source && <TextField
              select
              label="Select Internal Location"
              size="small"
              fullWidth
              margin="normal"
              variant="outlined"
              name="sourceId"
              value={localReviewData.sourceId}
              onChange={handleChange}
            >
              {internalLocations?.length === 0 ? (
                <MenuItem disabled>{"No internal locations found"}</MenuItem>
              ) : (
                internalLocations
                  ?.slice()
                  ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                  ?.map((a) => (
                    <MenuItem key={a.sourceId} value={a.sourceId}>
                      {a.name}
                    </MenuItem>
                  ))
              )}
            </TextField>}
            <TextField
              label="Author Name"
              size="small"
              fullWidth
              margin="normal"
              variant="outlined"
              name="authorName"
              value={localReviewData.authorName}
              onChange={handleChange}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <TextField
                select
                label="Rating"
                size="small"
                sx={{ width: "20%" }}
                margin="normal"
                variant="outlined"
                name="rating"
                value={localReviewData.rating}
                onChange={handleChange}
              >
                {[1, 2, 3, 4, 5].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                type="date"
                label="Review Date"
                size="small"
                sx={{ width: "40%" }}
                margin="normal"
                variant="outlined"
                name="reviewDate"
                value={localReviewData?.reviewDate?.split("T")[0]}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>

            <TextField
              label="Review Text"
              size="small"
              fullWidth
              margin="normal"
              variant="outlined"
              multiline
              rows={4}
              name="reviewText"
              value={localReviewData.reviewText}
              onChange={handleChange}
            />
             <TextField
                type="date"
                label="Response Date"
                size="small"
                sx={{ width: "40%" }}
                margin="normal"
                variant="outlined"
                name="responseDate"
                value={localReviewData?.responseDateTime?.split("T")[0]}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
           

            <TextField
              label="Response Text"
              size="small"
              fullWidth
              margin="normal"
              variant="outlined"
              multiline
              rows={4}
              name="responseText"
              value={localReviewData.responseText}
              onChange={handleChange}
            />
            
          </DialogContent>
          <Divider />
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={handleSave}
              disabled={isSaveDisabled()}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="error"
              sx={{ ml: 2 }}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            </Box>


           {isEditMode && <Button
              size="small"
              variant="outlined"
              color="error"
              sx={{ ml: 2 }}
              onClick={handleDelete}
            >
              Delete
            </Button>}

            


          </div>
        </Dialog>
      )}
    </div>
  );
};

const initialReviewState = {
  sourceId: "",
  authorName: "",
  reviewDate: "",
  rating: "",
  reviewText: "",
  responseText:null,
  responseDate:null
};

export default ReviewModal;
